import React, { useEffect, useState } from 'react'
import Modal from '../../../../common/modal'
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import DropDownOA from '../../../../common/dropDownOA'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { satusList } from '../../GSConstants'
import { focusElemnt } from '../../../../common/helper'
import * as mdt from '../../../../common/modaltypes'

const AssignFormatModal = (props) => {
  const { updateModal, headTxt, isUpdate, branchList, AssignCargoTicketFormat, loginData, mode, TicketFormatID } = props
  const [selectedBranches, setSelectedBranches] = useState({})
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  const columnDefs = [
    {
      headerName: 'Status',
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '2%' },
      field: 'select',
      dataType: 'string',
      showfilter: false,
      allowSorting: false,
    },
    {
      headerName: 'Branch Name',
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '12%' },
      field: 'paymentType',
      dataType: 'string',
      showfilter: true,
      allowSorting: false,
    },
    {
      headerName: 'Currently Assigned Format',
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '10%' },
      field: 'delHamali',
      dataType: 'number',
      showfilter: true,
      allowSorting: false,
    },
  ]
  const handleCheckboxChange = (branchID) => {
    setSelectedBranches((prevSelectedBranches) => {
      return {
        ...prevSelectedBranches,
        [branchID]: !prevSelectedBranches[branchID], // Toggle the value
      }
    })
  }

  useEffect(() => {
    focusElemnt('selAutoDelByCity')
  }, [])
  const InsideRowContent = (props) => {
    const { item, index } = props
    return (
      <TableRow key={`auto-trans-recv-${index}`} style={{ minHeight: '36px' }}>
        <TableCell
          style={{ textAlign: '-webkit-center', fontSize: '12px', minHeight: '36px', color: '#444444', width: '2%', padding: '0px 8px' }}
        >
          <Item className="checkbox-ctrl" style={{ padding: '0px 8px', backgroundColor: 'transparent' }}>
            <FormControlLabel
              value="end"
              control={
                <Checkbox
                  id={`chkbox-${index}`}
                  checked={selectedBranches[item.BranchID] || false}
                  onChange={() => handleCheckboxChange(item.BranchID)}
                  sx={{ fontSize: '12px', backgroundColor: 'transparent !important', height: '36px', verticalAlign: 'middle' }}
                  // onKeyDown={(e) => {
                  //     navigation1(e, `checkMark-${index}`, `mopPkngMethod-${index}`)
                  // }}
                />
              }
              labelPlacement="end"
            />
          </Item>
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '12%', padding: '0px 8px' }}>
          {item.BranchName}
        </TableCell>
        <TableCell style={{ textAlign: 'left', fontSize: '12px', minHeight: '36px', color: '#444444', width: '10%', padding: '0px 8px' }}>
          {item.TicketFormatName}
        </TableCell>
      </TableRow>
    )
  }
  const handleSave = () => {
    const branchIDs = Object.keys(selectedBranches).filter(key => selectedBranches[key]);
    branchIDs.forEach((branchID) => {
      const body = {
        intBranchID: parseInt(branchID),
        intTicketFormatID: parseInt(TicketFormatID),
        Mode: mode,
      }
      AssignCargoTicketFormat(body)
        .then((res) => {
          if (res.status === 'Success') {
            updateModal(false, mdt.ticketFormat)
          } else {
            // Handle error for each branchID if needed
          }
        })
        .catch((err) => {
          console.log('Error:', err)
          // Handle error for each branchID if needed
        })
    })

    // Additional logic after all API calls, if needed
  }

  return (
    <Modal
      headTxt={headTxt}
      width={'40%'}
      updateModal={updateModal}
      closeId={'closeButton'}
      modalClass={'booking-popup'}
      modalStyle={modalStyle}
    >
      <Stack style={{ maxHeight: '60vh', paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px' }}>
        <TableContainer
          className="lr-popup-table lrModel  scrollBlue"
          style={{ border: '1px solid #ddd', borderBottomLeftRadius: '0px' }}
          component={Paper}
        >
          <Table
            style={{ border: 'none', overflow: 'auto' }}
            stickyHeader
            id="focApprovalTbl"
            className="table1 table-Received "
            size="small"
            aria-label="a dense table"
          >
            <TableHead style={{ position: `sticky`, top: `0`, background: `white`, zIndex: '2' }}>
              <TableRow key="foc-tbl-header" style={{ background: '#d9edff', height: '36px' }}>
                {columnDefs.map((col, index) => (
                  <TableCell
                    key={`TH-${index}`}
                    style={{
                      ...col.headerSx,
                      verticalAlign: 'top',
                      backgroundColor: '#DAEDFE',
                      minHeight: '36px',
                      fontFamily: 'Roboto',
                      fontSize: '12px',
                      fontWeight: '600',
                      color: '#444444',
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                      {col.headerName.split('\n').map((line, lineIndex) => (
                        <span key={`line-${lineIndex}`} style={{}}>
                          {line}
                        </span>
                      ))}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody className="filter-data-row" style={{ border: 'none' }}>
              {branchList?.map((item, index) => (
                <InsideRowContent item={item} index={index} key={index} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {/* <Divider/> */}
        <Box sx={{ display: 'flex', padding: '12px 0px' }}>
          <Button
            className="cancel-btn"
            variant="outlined"
            color="error"
            style={{ height: '40px', color: '#fe5200', fontSize: 'medium', marginLeft: 'auto', marginRight: '12px' }}
            onClick={() => {
              isUpdate ? updateModal(false, mdt.ticketFormat) : updateModal(false, mdt.ticketFormat)
            }}
          >
            Cancel
          </Button>
          <Button
            id="mopAddBtn"
            style={{ margin: '0', height: '40px' }}
            className="btn add-btn"
            variant="contained"
            color="error"
            onClick={() => {
              handleSave()
            }}
            // onKeyDown={(e) => {
            //     navigation1(e, `editBtn-0`, 'mopActive');
            // }}
          >
            {isUpdate ? 'Update' : 'Save'}
          </Button>
        </Box>
      </Stack>
    </Modal>
  )
}

export default AssignFormatModal
